export default interface CrossSellSetupResponse {
  RestaurantId: number;
  Name: string;
  MaxOnlinePartySize: number;
  MinOnlinePartySize: number;
  OnlinePartySizeDefault: number;
  FullAddress: string;
  MapLink: string;
  CurrencySymbol: string;
  CurrencyCode: string;
  TimeZoneName: string;
  CultureName: string;
  CountryCode: string;
  Iso2CountryCode: string;
  TermsAndConditions: string;
  Latitude: number | null;
  Longitude: number | null;
  PrivacyPolicy: string;
  IsIndividualVenueMarketingEnabled: boolean;
  IsGroupMarketingEnabled: boolean;
  GroupMarketingDisplayName: string;
  StripeInfo: RestaurantSetupStripeInfo;
  TrackingSettings: WidgetTrackingDetails;
  CrossSellVenues: CrossSellVenue[];
  ThemeStyles: WidgetThemeStyles | null;
  ThemeSettings: WidgetThemeSettings | null;
  CustomField: CustomField | null;
  UseNewSkipTimeSelectFlow: boolean;
  UseConfirmationTokenStripeFlow: boolean;
  TurnstileSiteKey: string;
  UseTurnstile: boolean;
  EnforceTurnstile: boolean;
  TurnstileSize: string;
  TurnstileAppearance: string;
}

export interface CrossSellVenue {
  Name: string;
  MicrositeName: string;
  Address: string;
  City: string;
  Latitude: number | null;
  Longitude: number | null;
  Priority: number;
}

export interface RestaurantSetupStripeInfo {
  StripePublishableKey: string;
  UseLiveToken: boolean | null;
  IsEnabled: boolean | null;
}

export interface WidgetTrackingDetails {
  GoogleAnalyticsId: string;
  GoogleTagManagerId: string;
  GoogleAnalytics4Id: string;
  GoogleAdWordsId: string;
  GoogleAdWordsLabel: string;
  FacebookPixelId: string;
  TwitterAdId: string;
}

export interface WidgetThemeStyles {
  ThemeId: number;
  OverallResDiaryLogo: number;
  OverallGeneralBackgroundColour: string;
  OverallGeneralTextColour: string;
  OverallGeneralTableReturnNoticeColour: string;
  OverallGeneralBorderRadius: number;
  OverallGeneralFont: string;
  OverallBookButtonColour: string;
  OverallBookButtonFontColour: string;
  OverallMessageTextColour: string;
  OverallMessageBackgroundColour: string;
  BookingSummaryBackgroundColour: string;
  BookingSummaryTextColour: string;
  BookingSummaryBorderRadius: number;
  CalendarBackgroundColour: string;
  CalendarBorderColour: string;
  CalendarMonthDayTextColour: string;
  CalendarBorderRadius: number;
  CalendarDayTextColour: string;
  CalendarDayBackgroundColour: string;
  CalendarDayBorderRadius: number;
  CalendarSelectedTextColour: string;
  CalendarSelectedBackgroundColour: string;
  PromoBoxBorderColour: string;
  PromoBoxBorderRadius: number;
  PromoOptionBackgroundColour: string;
  PromoOptionTextColour: string;
  PromoOptionHoverBackgroundColour: string;
  PromoOptionHoverTextColour: string;
  PromoSelectedBackgroundColour: string;
  PromoSelectedTextColour: string;
  DropdownGeneralBackgroundColour: string;
  DropdownGeneralTextColour: string;
  DropdownGeneralValidationErrorColour: string;
  DropdownGeneralPlaceholderColour: string;
  DropdownBorderColour: string;
  DropdownBorderFocusColour: string;
  DropdownBorderRadius: number;
  DropdownSelectedBackgroundColour: string;
  DropdownSelectedTextColour: string;
  CustomLogoUrl: string;
}

export interface WidgetThemeSettings {
  ChannelCode: string;
  CustomSuccessPageUrl: string;
  FixedPromotionId: boolean | null;
  SkipPromotionsScreen: boolean;
  DivideTimeSlotsByService: boolean;
  IsChildrenCoversShown: boolean;
  IsInfantsCoversShown: boolean;
  AllowAreaChoice: boolean;
  IncludeAnyArea: boolean;
  ShowCustomerTitle: boolean;
  ShowTelephoneNumberField: boolean;
  ShowCompanyField: boolean;
  ShowPostcodeField: boolean;
  PostcodeRequired: boolean;
  ShowHouseholdsField: boolean | null;
  ShowDateOfBirth: boolean;
  ShowDateOfBirthYear: boolean;
  DateOfBirthRequired: boolean;
  DateOfBirthDescription: string;
  ShowSmsMarketingOption: boolean;
  ShowOptinCheckboxes: boolean;
  ShowMobileNumberField: boolean;
  ShowMembershipIdField: boolean | null;
  MembershipIdTitle: string;
  IsMembershipIdRequired: boolean;
  ShowRoomNumberField: boolean | null;
  WidgetBookingType: WidgetBookingType;
  MarketingLevel: MarketingLevel | null;
  ContactDetailsTitle: string;
  PrecheckVenueEmailOptin: boolean | null;
  ShowCommentsField: boolean;
}

export interface CustomField {
  Number: number;
  Name: string;
  IsRequired: boolean;
}

export enum WidgetBookingType {
  Booking = "Booking",
  Event = "Event",
  Marketing = "Marketing",
}

export enum MarketingLevel {
  None = "None",
  VenueAndGroup = "VenueAndGroup",
  VenueOnly = "VenueOnly",
  GroupOnly = "GroupOnly",
}
